export default "__VITE_ASSET__Bgos5XVE__"